import "./style/myTasks.css";
import { useContext, useLayoutEffect } from "react";
import AddTask from "./AddTask";
import ResetTasks from "./ResetTasks";
import { AppMainContext } from "../context/AppMainContext";
import MyTasks_topSection from "./MyTasks_topSection";
import ShowHistory from "./ShowHistory";

export default function MyTasks() {
    
    const { handleClock, deployTasks } = useContext(AppMainContext);

    useLayoutEffect(()=>{
        handleClock();
    },[])

    return (
        <div className="myTasks_div">
            <MyTasks_topSection/>
            <ResetTasks/>
            <ShowHistory/>
            <h1 className="myTasks_mainHeader">הלו''ז היומי</h1>
            <AddTask/>
            <div className="myTasks_listDiv">{deployTasks()}</div>
        </div>
    )
}
